// loginReducer.js
import {
  AUTH_INIT_START,
  AUTH_INIT_FINISH,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
} from "../Actions/Actions";

const initialData = {
  user: null,
  actions: null,          // null => not hydrated yet
  isLoading: false,
  isBootstrapping: true,  // gate UI until we hydrate once
  error: "",
};

export default function loginReducer(state = initialData, { type, payload }) {
  switch (type) {
    case AUTH_INIT_START:
      return { ...state, isBootstrapping: true };

    case AUTH_INIT_FINISH:
      // Only flip the boot flag; don't mutate actions here
      return { ...state, isBootstrapping: false };

    case LOGIN_REQUEST:
      return { ...state, isLoading: true, error: "" };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isBootstrapping: false,        // once we have a real map, boot is done
        user: payload?.profile_data ?? null,
        actions: payload?.actions ?? {},  // stable map ({} means no access)
      };

    case LOGIN_FAILURE:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
}
